import React, { useEffect, useRef, useState } from "react";
import { NavBar, Cockpit } from "../components";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { ICockpit } from "../interfaces/ICockpit.interface";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { Navigate } from "react-router-dom";
import { Box } from "@mui/system";

const Launcher: React.FC = () => {
  const containerRef = useRef(null);
  // const [height, setHeight] = useState<number>(0);
  const [cockpits, setCockpits] = useState<ICockpit[]>();
  const [error, setError] = useState<boolean>(false);
  // if (containerRef.current!.height) {
  //   setHeight(containerRef.current.height);
  // }
  console.log(containerRef.current);
  const getData = async () => {
    try {
      const response = await fetch(
        `${process.env.PUBLIC_URL}/cockpitsData.json`
      );
      const data = await response.json();
      setCockpits(data);
      setError(false);
    } catch (err) {
      setError(true);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (error) {
    return (
      <div className="flex justify-center items-center w-full h-full">
        <div className="bg-white p-8 rounded-sm shadow-sm flex justify-center items-center">
          <p>Error loading data</p>
        </div>
      </div>
    );
  }
  return (
    <>
      <AuthenticatedTemplate>
        <div
          style={{
            backgroundImage: "url('/bg.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundAttachment: "fixed",
            height: "100vh",
            overflow: "hidden",
          }}
          className="flex flex-col items-center"
        >
          <NavBar />
          <div
            ref={containerRef}
            className="flex justify-center my-4 px-4 pb-4 max-w-screen-xl w-full overflow-y-auto"
          >
            {cockpits && (
              <Grid container spacing={4}>
                {cockpits.map((cockpit, i) => (
                  <Grid item xs={12} md={6} lg={4} key={i}>
                    <Cockpit
                      title={cockpit.name}
                      subtitle={cockpit.type}
                      image={cockpit.image}
                      color={cockpit.color}
                      link={cockpit.link}
                    />
                  </Grid>
                ))}
              </Grid>
            )}
          </div>
        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Navigate to="/login" />
      </UnauthenticatedTemplate>
    </>
  );
};

export default Launcher;
